import React from 'react';
export const Overlay = props => {
    return (
        <div
            className={`overlay ${ props.overlayType === "nav" ? "nav-overlay" : "about-overlay" }`}
            style={{display: props.isOverlay ? "flex" : "none"}}
            role='dialog'
        >
            <div className='overlay-animate--container'>
                <span className='overlay-animate'></span>
            </div>
            <div className='overlay-content'>
                {props.children}
            </div>
        </div>
    );
};
